import React from "react";

export default function TermsAndCondition() {
  return (
    <div class="max-w-screen-lg mx-auto py-8 px-4">
      <h1 class="text-3xl font-bold text-center text-gray-900 mb-6">
        Terms and Conditions
      </h1>

      <p class="text-gray-700 mb-4">
        Welcome to Mobi POS! By using this website, you agree to comply with and
        be bound by the following terms and conditions. If you disagree with any
        part of these terms, you must not use our website.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-3">
        1. Website Overview
      </h2>
      <p class="text-gray-700 mb-4">
        Mobi POS is a website dedicated to showcasing Point of Sale (POS)
        devices and their specifications. Please note that this website does not
        sell or facilitate the purchase of any devices. The information provided
        is purely for informational purposes to help users explore device
        features.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-3">
        2. No Data Collection
      </h2>
      <p class="text-gray-700 mb-4">
        Mobi POS does not collect or store any personal data or information from
        users. You can browse the device specifications without creating an
        account or providing any personal information. We do not use cookies,
        tracking technologies, or store any form of data locally.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-3">
        3. Use of Information
      </h2>
      <p class="text-gray-700 mb-4">
        All content provided on the Mobi POS website, including but not limited
        to device specifications, images, and descriptions, is for informational
        purposes only. The information is subject to change without notice and
        is not intended to replace professional advice or make purchasing
        decisions.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-3">
        4. Limitation of Liability
      </h2>
      <p class="text-gray-700 mb-4">
        Mobi POS shall not be held liable for any direct or indirect damages
        arising from the use of this website, including inaccuracies or
        omissions in the information provided. Users are encouraged to verify
        device specifications directly with manufacturers before making any
        decisions based on the content of this website.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-3">
        5. External Links
      </h2>
      <p class="text-gray-700 mb-4">
        Our website may contain links to third-party websites. These links are
        provided for your convenience only, and we do not endorse or assume
        responsibility for the content or practices of such external sites.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-3">
        6. Intellectual Property
      </h2>
      <p class="text-gray-700 mb-4">
        All content on this website, including text, images, and graphics, is
        the intellectual property of Mobi POS or its respective licensors. You
        may not use, reproduce, or distribute any content without prior written
        permission.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-3">
        7. Modifications to Terms
      </h2>
      <p class="text-gray-700 mb-4">
        Mobi POS reserves the right to update or modify these terms and
        conditions at any time without prior notice. By continuing to use the
        website after any changes are posted, you accept and agree to be bound
        by the updated terms.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-3">8. Contact Us</h2>
      <p className="mb-4 ml-5">
        If you have any questions about this Terms and Condition, You can
        contact us:
      </p>
      <div className="ml-5">
        <div className="ml-5">
          <p>
            <b>By sending us an email : </b>{" "}
            <a
              href="mailto:mobipos@spidertechnosoft.com"
              className="text-blue-600 hover:underline hover:text-blue-700"
            >
              mobipos@spidertechnosoft.com
            </a>
          </p>
          <p>
            <b>Contact Number : </b>{" "}
            <a
              href="tel:+917736904688"
              className="text-blue-600 hover:underline hover:text-blue-700"
            >
              +91 77369 04688
            </a>{" "}
            /{" "}
            <a
              href="tel:+919995801797"
              className="text-blue-600 hover:underline hover:text-blue-700"
            >
              +91 99958 01797
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
